import { render, staticRenderFns } from "./MaintainUser.vue?vue&type=template&id=0f264bc4&scoped=true"
import script from "./MaintainUser.vue?vue&type=script&lang=js"
export * from "./MaintainUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f264bc4",
  null
  
)

export default component.exports